import { render, staticRenderFns } from "./ManagePageFormLayout.vue?vue&type=template&id=58bdc8bd&"
import script from "./ManagePageFormLayout.vue?vue&type=script&lang=js&"
export * from "./ManagePageFormLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports